import { Button } from "@jewlr/storybook/core"
import styled from "styled-components"

export const SizeBox = styled(Button).attrs((props) => ({
  fontSize: "20px",
  variant: "text",
  ...props,
}))`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  align-items: center;
  background-color: white;
  border: 1px solid #646464;
  border-radius: 50%;
  color: #646464;
  display: flex;
  font-weight: 500;
  height: 66px;
  justify-content: center;
  line-height: 13px;
  min-height: 66px;
  min-width: 66px;
  padding-top: 2px;
  position: relative;
  transition: all 250ms ease-in;
  user-select: none;

  &:hover,
  &:active,
  &:focus {
    outline: none;
  }

  &:focus {
    border: 2px solid ${(props) => props.theme.colors.selected};
  }

  ${(props) =>
    props.availableHoliday &&
    `
    background-color: #DBF0CF;
    border-color: #00A900;
  `}

  ${(props) =>
    props.selected &&
    `
    border: 2px solid #1ABBDA;
    box-shadow: 0 0 2px #1ABBDA;
    &:after {
      display: block;
      position: absolute;
      content: url(${require("images/icons/checkmark.svg")});
      transform: scale(0.05);
      bottom: -4px;
      left: 50%;
      margin-left: -18px;
      width: 22px;
      height: 22px;
    }
  `}
`

export const WidthSizeBox = styled.div`
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  align-items: center;
  background-color: ${(props) => (props.selected ? "white" : "none")};
  border: ${(props) => (props.selected ? "2px solid" : "none")};
  border-color: ${(props) => (props.selected ? "#1ABBDA" : "#646464")};
  border-radius: 6px;
  box-shadow: ${(props) => (props.selected ? "0 0 2px #1ABBDA" : "none")};
  color: #646464;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  font-weight: 500;
  height: 75px;
  justify-content: flex-end;
  line-height: 13px;
  min-height: 75px;
  min-width: 75px;
  padding-top: 2px;
  transition: all 100ms ease-in;
  user-select: none;

  &:hover,
  &:active {
    outline: none;
  }
`

export const SizeBoxSmall = styled.div`
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  align-items: center;
  background-color: white;
  border: 1px solid;
  border-color: ${(props) => (props.selected ? "#1ABBDA" : "#646464")};
  border-radius: 50%;
  box-shadow: ${(props) => (props.selected ? "0 0 3px #1ABBDA" : "none")};
  color: #646464;
  display: flex;
  font-size: 12px;
  font-weight: 500;
  height: 40px;
  justify-content: center;
  line-height: 9px;
  margin: 0 15px 0 4px;
  max-height: 40px;
  max-width: 40px;
  min-height: 40px;
  min-width: 40px;
  transition: all 300ms ease-in;
`

export const Size = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`

export const SizeContainer = styled.div`
  flex-basis: auto;
  padding: 8px 15px;
  text-align: center;
`

export const WidthSizeContainer = styled.div`
  flex-basis: auto;
  padding: 8px 15px 8px 1px;
  text-align: center;
`

export const TipText = styled(Button).attrs({
  variant: "text",
})`
  align-items: center;
  color: ${(props) => props.theme.colors.primary};
  display: flex;
  font-size: 14px;
  justify-content: center;
  margin: auto;
  span {
    margin-left: 8px;
  }
`
